module.exports = __webpack_public_path__ + "img/lkzb.bb8467bb.png";